package twist.mena.sports.shared.dto.ads

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateAdRequest(
    @SerialName("ad_type") val adType: String,
    @SerialName("ad_location") val adLocation: String = "",
    @SerialName("ios_ad_id") val iosAdId: String = "",
    @SerialName("android_ad_id") val androidAdId: String = ""
)
